import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './maintenance.page.html',
  styleUrl: './maintenance.page.scss'
})
export class MaintenancePage {
  readonly whatsappNumber = environment.whatsappNumber;

  reload(): void {
    document.location.reload();
  }
}
